import { Formik } from 'formik';
import { useState, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBackIosNew } from 'react-icons/md';
import { categorySchema } from '../../../../../constants';
import { DAV_APIS } from '../../../../../adapters';
import { Alert, SEO } from '../../../../commons';
import CategoryForm from '../CategoryForm';
import { Button } from '../../../../ui/Button';

const NewCategoryPage: FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const newCategorySubmitHandler = async (values: any) => {
    setLoading(true);
    try {
      const data = {
        name: values.title,
        description: values.description,
        country: values.country,
        categoryImage: values.imageFile,
        value: values.title,
      };
      const res = await DAV_APIS.country.createCategory(data);
      setLoading(false);
      if (res.status === 201) {
        Alert({ variant: 'success', message: 'Category created successfully' });
        navigate('/dashboard/categories');
      }
    } catch (error) {
      setLoading(false);
      Alert({ variant: 'error', message: 'Failed to create category, Please try again' });
    }
  };

  return (
    <div className='w-full space-y-6 pt-4 pb-10'>
      <div className='flex items-center'>
        <button
          onClick={() => navigate('/dashboard/categories')}
          type='button'
          className='flex items-center gap-2 text-gray-500 hover:text-primary-600 transition-colors font-semibold'
        >
          <MdArrowBackIosNew className='w-4 h-4' />
          <span>Back to Categories</span>
        </button>
      </div>

      <Formik
        enableReinitialize
        initialValues={{
          title: '',
          description: '',
          imageCover: '',
          imageFile: '',
          country: '',
        }}
        validationSchema={categorySchema}
        onSubmit={async (values, { resetForm }) => {
          await newCategorySubmitHandler(values);
          resetForm();
        }}
      >
        {({ handleSubmit, values, setFieldValue, dirty, isValid }) => (
          <div className='space-y-10'>
            <div className='bg-white dark:bg-gray-800 rounded-2xl p-8 border border-gray-100 dark:border-gray-700 shadow-sm'>
              <h1 className='text-3xl font-extrabold text-gray-900 dark:text-white mb-8 text-center tracking-tight'>
                Add New Category
              </h1>

              <form onSubmit={handleSubmit} className='w-full'>
                <CategoryForm values={values} setFieldValue={setFieldValue} />
                <div className='flex justify-center mt-10 border-t border-gray-100 dark:border-gray-700 pt-8'>
                  <Button
                    type='submit'
                    variant='primary'
                    loading={loading}
                    disabled={!dirty || !isValid}
                    className='w-full sm:w-64'
                  >
                    Create Category
                  </Button>
                </div>
              </form>
            </div>
            <SEO
              pageType='category'
              initialData={{
                title: values.title,
                description: values.description,
                image: values.imageCover,
              }}
            />
          </div>
        )}
      </Formik>
    </div>
  );
};

export default NewCategoryPage;
